// extracted by mini-css-extract-plugin
module.exports = {"slider":"SliderRepas_slider__2_Ois","slide":"SliderRepas_slide__cOAzg","feat":"SliderRepas_feat__Ln_Rm"};